<template>
  <div
    class="input-container"
    :class="{ 'required-fail': requiredFail }"
    style="position: relative"
  >
    <input
      type="datetime-local"
      :value="dateTimeValue"
      @change="setDateTimeValue($event.target.value)"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
      style="width: 100%"
    />

    <v-btn
      v-if="!disabled && !required && value"
      @click="updateValue(null)"
      x-small
      text
      icon
      class="form-input-clear-button"
    >
      <v-icon size="15">
        clear
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeDateTime",

  mixins: [inputTypeMixin],

  props: {
    step: {
      type: Number | String
    },

    min: {
      type: Number | String
    },

    max: {
      type: Number | String
    },

    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    //input was not reading when the date was sent from mobile to BE, receives value turns it into a new date, then converts in date readable format.
    dateTimeValue() {
      if (this.value) {
        let date = new Date(this.value);
        date.setHours(date.getHours() + 1);
        let dateTime = date.toISOString().substring(0, 16);
        return dateTime.replace(" ", "T");
      } else return null;
    }
  },

  methods: {
    setDateTimeValue(value) {
      if (value) {
        value = value.replace("T", " ");
      }
      this.updateValue(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeDateTime.vue